"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _Constant = require("../../Constant");

var _Deprecated = require("../../Deprecated");

var _theme;

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-top: 15px;\n  line-height: 1.625;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-bottom: 20px;\n  padding-top: ", ";\n\n  @media print, screen and (min-width: ", "px) {\n    margin-bottom: 10px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var headerColor = (0, _styledTheming.default)('mode', (_theme = {}, (0, _defineProperty2.default)(_theme, _Constant.Themes.CALIBER, "".concat(_Constant.Color.BLACK_SOUL)), (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEPOINT, "".concat(_Constant.Color.BLACK_SOUL)), (0, _defineProperty2.default)(_theme, _Constant.Themes.FIGURE, "".concat(_Constant.Color.PURPLE_RAIN)), (0, _defineProperty2.default)(_theme, _Constant.Themes.PETERSENDEAN, "".concat(_Constant.Color.PURPLE_RAIN)), (0, _defineProperty2.default)(_theme, _Constant.Themes.PELLA, "".concat(_Constant.Color.PURPLE_RAIN)), _theme));

var Container = _styledComponents.default.div(_templateObject(), function (props) {
  return props.$topMargin ? '25px' : '0';
}, _Constant.Width.MD);

var Header = _styledComponents.default.h1(_templateObject2(), headerColor);

var H3 = (0, _styledComponents.default)(_Deprecated.TertiaryHeader)(_templateObject3());

var TwoColumnMainHeader = function TwoColumnMainHeader(_ref) {
  var text = _ref.text,
      subText = _ref.subText,
      semanticElement = _ref.semanticElement,
      topMargin = _ref.topMargin;
  return text && /*#__PURE__*/_react.default.createElement(Container, {
    $topMargin: topMargin
  }, /*#__PURE__*/_react.default.createElement(Header, null, text), subText && /*#__PURE__*/_react.default.createElement(H3, {
    as: semanticElement
  }, subText));
};

TwoColumnMainHeader.propTypes = {
  text: _propTypes.default.node,
  subText: _propTypes.default.string,
  semanticElement: _propTypes.default.string,
  topMargin: _propTypes.default.bool
};
TwoColumnMainHeader.defaultProps = {
  text: '',
  subText: '',
  semanticElement: null,
  topMargin: false
};
var _default = TwoColumnMainHeader;
exports.default = _default;